import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 2.75,
		y: 2.75,
		width: 18.5,
		height: 18.5,
		rx: 1.25,
		stroke: "#E5EAF0",
		strokeWidth: 1.5
	})
});
export default SvgCheckboxOff;
